import React, { useMemo } from 'react';
import Select from 'react-select';
import { TimePicker } from 'antd';
import InclusionHeaderRow from '../common/InclusionHeaderRow';

const SightseeingInclusion = ({
    disabled,
    isSightseeingIncluded,
    sightseeinglistdata,
    sightseeingid,
    handlesightseeingchange,
    sightseeingdisable,
    sightseeingopen,
    handleSightseeing,
    sightseeingname,
    formvalue,
    hoursTime,
    vehicalistdata,
    vehicaltypeid,
    handlevehicaltype,
    vehicalprice
}) => {
    const selectedVehicle = useMemo(
        () => vehicalistdata?.find(item => item.value === vehicaltypeid) || null,
        [vehicalistdata, vehicaltypeid]
    );

    return (
        <>
            <InclusionHeaderRow
                label="Add Sightseeing"
                required={false}
                datalist={sightseeinglistdata}
                fieldid={sightseeingid}
                onSelectionChange={handlesightseeingchange}
                isDisabled={disabled || !isSightseeingIncluded}
                isActiveDisable={sightseeingdisable}
                isSearchable
                isOpen={sightseeingopen}
                onToggle={handleSightseeing}
                buttonDisabled={!isSightseeingIncluded}
            />

            {sightseeingopen && (
                <div className="col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 mb-1">
                            <label className="col-form-label">{sightseeingname}</label>
                        </div>
                        <div className="col-lg-12 col-sm-12">
                            <div className="row">
                                <div className="col-lg-1 col-md-2 mb-1">
                                    <label className="col-form-label">Pick Up Point</label>
                                </div>
                                <div className="col-lg-3 mb-1 col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="PickupPoint"
                                        disabled
                                        value={formvalue?.PickUpPoint || ''}
                                        placeholder="PickUpPoint"
                                        readOnly
                                    />
                                </div>
                                <div className="col-lg-1 col-md-2 mb-1">
                                    <label className="col-form-label">Drop Point</label>
                                </div>
                                <div className="col-lg-3 mb-1 col-md-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="DropPoint"
                                        disabled
                                        value={formvalue?.DropPoint || ''}
                                        placeholder="DropPoint"
                                        readOnly
                                    />
                                </div>
                                <div className="col-lg-1 col-md-3 mb-1">
                                    <label className="col-form-label">Duration</label>
                                </div>
                                <div className="col-lg-3 mb-1 col-md-6">
                                    <TimePicker
                                        id="Hours"
                                        className="form-control defo_border"
                                        disabled
                                        placeholder="--"
                                        format="HH"
                                        value={hoursTime}
                                        needConfirm={false}
                                        showNow={false}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-sm-12">
                            <div className="row">
                                <div className="col-lg-2 col-md-12 mb-1">
                                    <label className="col-form-label">Itinerary Details</label>
                                </div>
                                <div className="col-lg-10 mb-1 col-md-12">
                                    <textarea
                                        className="form-control"
                                        name="ItineraryDetails"
                                        value={formvalue?.ItineraryDetails || ''}
                                        disabled
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-sm-6">
                            <div className="row">
                                <div className="col-lg-2 col-md-12 mb-1">
                                    <label className="col-form-label">Select Vehicle</label>
                                </div>
                                <div className="col-lg-4 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={vehicalistdata}
                                        value={selectedVehicle}
                                        onChange={handlevehicaltype}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label htmlFor="inputPassword7" className="col-form-label">Price</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <input
                                        type="text"
                                        id="inputPassword7"
                                        className="form-control"
                                        name="VehicalPrice"
                                        disabled
                                        value={vehicalprice}
                                        placeholder="Vehicle Price"
                                        readOnly
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(SightseeingInclusion);

